module.exports = __webpack_public_path__ + "img/clube7.fe062b03.jpeg";